import { useEffect, useState } from 'react';

const utcDay = (date: Date): string => date.toISOString().slice(0, 10);

// The current UTC calendar day (`YYYY-MM-DD`), re-rendering when it changes. A page that stays open across UTC
// midnight would otherwise keep asking for yesterday's window, or last month's period on the 1st. Browsers
// throttle timers in background tabs, so the day is also re-read whenever the tab becomes visible again.
export function useUtcDay(): string {
  const [day, setDay] = useState(() => utcDay(new Date()));
  useEffect(() => {
    const sync = () => setDay(utcDay(new Date()));
    const now = new Date();
    const nextMidnight = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1);
    const timer = setTimeout(sync, nextMidnight - now.getTime() + 1000);
    document.addEventListener('visibilitychange', sync);
    return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', sync); };
  }, [day]);
  return day;
}

// Noon keeps every UTC-date computation on the intended day regardless of the reader's offset.
export function utcDayDate(day: string): Date {
  return new Date(`${day}T12:00:00Z`);
}
